import React from "react";
import { makeStyles, Tab, TabList, tokens } from "@fluentui/react-components";
import { privateNavItems, publicNavItems } from "./Navigation.data";
import { RouteEnum, useRoute } from "../../../contextApis/RouteContext";
import { NavigationProps } from "./Navigation.types";
import RenderIf from "../RenderIf/RenderIf";

const useStyles = makeStyles({
  navContainer: {
    width: "100%",
    backgroundColor: tokens.colorNeutralBackground1,
    borderBottom: `1px solid ${tokens.colorNeutralStroke1}`,
    position: "sticky",
    top: 0,
    zIndex: 100,
  },
  toggleButton: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "4px",
    backgroundColor: "transparent",
    border: "none",
    cursor: "pointer",
  },
  tabList: {
    display: "flex",
    width: "100%",
    "& .fui-Tab__content--reserved-space": {
      display: "none",
    },
  },
  tab: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "4px",
    padding: "8px 16px",
    minWidth: "0",
    flex: 1,
  },
  tabIcon: {
    fontSize: "24px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  tabLabel: {
    fontSize: tokens.fontSizeBase200,
    transition: "opacity 0.2s ease",
  },
});

const Navigation: React.FC<NavigationProps> = ({ isLoggedIn }) => {
  const styles = useStyles();
  const { currentRoute, navigate } = useRoute();

  const handleTabSelect = (route: string) => {
    navigate(route as RouteEnum);
  };

  return (
    <nav className={styles.navContainer}>
      <TabList
        appearance="subtle"
        className={styles.tabList}
        selectedValue={currentRoute}
        onTabSelect={(_, data) => handleTabSelect(data.value as string)}
      >
        <RenderIf shouldRender={isLoggedIn}>
          {privateNavItems.map((item) => (
            <Tab
              key={item.route}
              value={item.route}
              className={styles.tab}
              icon={
                <span className={styles.tabIcon}>
                  <item.icon />
                </span>
              }
            >
              <span className={styles.tabLabel}>{item.label}</span>
            </Tab>
          ))}
        </RenderIf>
        <RenderIf shouldRender={!isLoggedIn}>
          {publicNavItems.map((item) => (
            <Tab
              key={item.route}
              value={item.route}
              className={styles.tab}
              icon={
                <span className={styles.tabIcon}>
                  <item.icon />
                </span>
              }
            >
              <span className={styles.tabLabel}>{item.label}</span>
            </Tab>
          ))}
        </RenderIf>
      </TabList>
    </nav>
  );
};

export default Navigation;
